import React from 'react'
import { useTranslation } from 'react-i18next'
import { FieldType } from '../../Common/Types/Field'
import Dropdown from '../../Common/Components/Dropdown'

const options = [
  { value: 'OTA_USER', label: 'User' },
  { value: 'OTA_ADMIN', label: 'Admin' },
  { value: 'OTA_MANAGER', label: 'Manager' },
]

const RoleDropdown = ({ value, onChange, required, error, helperText, ...other }) => {
  const { t } = useTranslation()

  return (
    <Dropdown
      label={t('auth:fields.role')}
      required={required}
      value={value}
      onChange={onChange}
      options={options}
      error={error}
      helperText={helperText}
      {...other}
    />
  )
}

RoleDropdown.defaultProps = {
  required: false,
}

RoleDropdown.propTypes = FieldType

export default RoleDropdown
